import { render, staticRenderFns } from "./PendingList.vue?vue&type=template&id=97df4a2e"
import script from "./PendingList.vue?vue&type=script&lang=js"
export * from "./PendingList.vue?vue&type=script&lang=js"
import style0 from "./PendingList.vue?vue&type=style&index=0&id=97df4a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports